import { createSlice } from "@reduxjs/toolkit";
const videoSlice = createSlice({
  name: "video",
  initialState: { videoId: null },
  reducers: {
    setVideoId: (state, action) => {
      state.videoId = action.payload;
    }
  }
});
const { setVideoId } = videoSlice.actions;
var stdin_default = videoSlice.reducer;
export {
  stdin_default as default,
  setVideoId
};
